import type { ProductContactGeometry } from "@przezmorze/api-types";

export function boundsContainingAll(locations: ProductContactGeometry[]) {
  if (locations.length === 0) {
    return undefined;
  }
  const viewports = locations.map((l) => {
    return new google.maps.LatLngBounds({
      east: l.viewport.northeast.lng,
      north: l.viewport.northeast.lat,
      west: l.viewport.southwest.lng,
      south: l.viewport.southwest.lat,
    } satisfies google.maps.LatLngBoundsLiteral);
  });
  return viewports.reduce((res, it) => res.union(it));
}
